var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { useBEM } from '../../../../../../utils';
import { isRangeMode, hasDateLimit, isSameDates, getWeeksOfMonths, } from '../../../../utils';
import { MONTHS_NAMES, WEEKDAYS } from '../../../../constants';
import "./styles.css";
var _a = useBEM('lk-ui_calendar-mobile'), _ = _a[0], calendarModifier = _a[1], calendarBlock = _a[2];
var _b = calendarBlock('months'), monthsClassName = _b[0], monthsModifier = _b[1];
export var Months = function (_a) {
    var minDate = _a.minDate, maxDate = _a.maxDate, disabledStartDate = _a.disabledStartDate, disabledEndDate = _a.disabledEndDate, viewDate = _a.viewDate, selectedDate = _a.selectedDate, onSelectDay = _a.onSelectDay, multiselect = _a.multiselect, readonly = _a.readonly;
    var today = new Date();
    var viewYear = viewDate.getFullYear();
    var viewMonth = viewDate.getMonth();
    var monthsWeeks = getWeeksOfMonths(viewYear);
    var monthsRef = useRef(null);
    useEffect(function () {
        var _a;
        /**
         * Скролл до активного месяца, поиск в рамках контейнера месяцев а не глобального document,
         * работает при MicroFrontend и shadowDOM
         * */
        var id = viewYear + "-" + viewMonth;
        var monthsObj = monthsRef === null || monthsRef === void 0 ? void 0 : monthsRef.current;
        (_a = monthsObj === null || monthsObj === void 0 ? void 0 : monthsObj.getElementsByClassName(id)[id]) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
    }, [viewYear, viewMonth, document]);
    var handleSelectDay = function (day, month, year) {
        if (day) {
            onSelectDay(day, month, year);
        }
    };
    var isCurrentDay = function (day, month, year) {
        if (day) {
            var checkedDate = new Date(year, month, day);
            return isSameDates(checkedDate, today);
        }
        return false;
    };
    var isSelectedDay = function (day, month, year) {
        if (day) {
            var checkedDate_1 = new Date(year, month, day);
            /**
             Расчёт стиля для контролла "День"
             + условие, что параметр "стартовая/конечная дата заблокирована для выбора" - disabledStartValue/disabledFinishValue может быть true
             */
            var getRangeModeSelectedDate = function () {
                if (disabledStartDate && disabledEndDate) {
                    return false;
                }
                if (disabledStartDate) {
                    return (Array.isArray(selectedDate) &&
                        selectedDate.indexOf(checkedDate_1) === 1);
                }
                if (disabledEndDate) {
                    return (Array.isArray(selectedDate) &&
                        selectedDate.indexOf(checkedDate_1) === 0);
                }
                return (Array.isArray(selectedDate) &&
                    (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.some(function (date) { return date && isSameDates(date, checkedDate_1); })));
            };
            return isRangeMode(selectedDate)
                ? getRangeModeSelectedDate()
                : selectedDate && isSameDates(selectedDate, checkedDate_1);
        }
        return false;
    };
    var isDisabledDay = function (day, month, year) {
        if (day) {
            var checkedDate = new Date(year, month, day);
            return hasDateLimit(checkedDate, minDate, maxDate);
        }
        return false;
    };
    var getRangeStatusOfDay = function (day, month, year) {
        if (multiselect)
            return {};
        if (day && isRangeMode(selectedDate)) {
            var startDay_1 = selectedDate[0], endDay_1 = selectedDate[1];
            var isFilledRange_1 = startDay_1 && endDay_1;
            var checkedDate_2 = new Date(year, month, day);
            /**
             Даты без учёта времени, приравняв часы в 00:00:00:000
             */
            var startDayMidnight = startDay_1 && new Date(new Date(startDay_1).setHours(0, 0, 0, 0));
            var endDayMidnight = endDay_1 && new Date(new Date(endDay_1).setHours(0, 0, 0, 0));
            /**
             Расчёт стартовой даты
             + условие, что параметр "стартовая дата заблокирована для выбора" - disabledStartValue может быть true
             */
            var getStarting = function () {
                if (disabledStartDate) {
                    return false;
                }
                return isFilledRange_1 && isSameDates(startDay_1, checkedDate_2);
            };
            /**
             Расчёт конечной даты
             + условие, что параметр "конечная дата заблокирована для выбора" - disabledFinishValue может быть true
             */
            var getEnding = function () {
                if (disabledEndDate) {
                    return false;
                }
                return isFilledRange_1 && isSameDates(endDay_1, checkedDate_2);
            };
            return {
                starting: getStarting(),
                ranging: startDayMidnight &&
                    startDayMidnight <= checkedDate_2 &&
                    endDayMidnight &&
                    endDayMidnight >= checkedDate_2,
                ending: getEnding(),
            };
        }
        return {};
    };
    return (React.createElement("div", { className: cn(calendarModifier('panel'), { readonly: readonly }) },
        React.createElement("table", { className: cn(calendarModifier('dates'), calendarModifier('panel-header')) },
            React.createElement("thead", { className: calendarModifier('weekdays') },
                React.createElement("tr", null, WEEKDAYS.map(function (weekday) { return (React.createElement("th", { className: calendarModifier('weekday'), key: weekday }, weekday)); })))),
        React.createElement("div", { ref: monthsRef, className: monthsClassName }, monthsWeeks.map(function (_a) {
            var month = _a.month, year = _a.year, monthWeeks = _a.monthWeeks;
            return (React.createElement("div", { key: year + "-" + month, id: year + "-" + month, className: cn(monthsModifier('month'), year + "-" + month) },
                React.createElement("span", { className: monthsModifier('month--title') }, MONTHS_NAMES[month] + " " + year),
                React.createElement("table", { className: calendarModifier('dates') },
                    React.createElement("tbody", { className: calendarModifier('weeks') }, monthWeeks.map(function (week, index) { return (React.createElement("tr", { key: "week-" + index }, week.map(function (day, index) {
                        var _a;
                        return (React.createElement("td", { className: cn(calendarModifier('day-cell'), __assign({}, getRangeStatusOfDay(day, month, year))), key: "day-" + index },
                            React.createElement("span", { className: cn(calendarModifier('day'), (_a = {
                                        today: isCurrentDay(day, month, year),
                                        disabled: isDisabledDay(day, month, year),
                                        selected: isSelectedDay(day, month, year),
                                        readonly: !!readonly
                                    },
                                    _a[calendarModifier('day__empty')] = day === null,
                                    _a)), onClick: function () { return handleSelectDay(day, month, year); } }, day)));
                    }))); })))));
        }))));
};
